import React, { FC, useState, useRef } from 'react';
import translate from '@translate';
import { checkFormValidity } from 'src/utils/formFunctions';
import TextField from 'src/components/TextField';
import Grid, { GridItem } from 'src/components/Grid';
import Button from 'src/components/Button';
import Typography from 'src/components/Typography';
import { colors, sizes } from 'src/themes/default';
import { EditKeysType } from './ProductsTable';
import { BillOfMaterialsProductType } from 'src/types/billOfMaterials';
import ProductsSelect from 'src/components/ProductsSelect';
import { FormErrorsType } from '../../types/global';

type NewProductBlockPropsType = {
    data?: BillOfMaterialsProductType[];
    onChange: (value: any) => void;
    disableEdit?: boolean;
    editErrors: FormErrorsType;
};

const initData: BillOfMaterialsProductType = { LINE_STATE: 'E' };

const NewProductBlock: FC<NewProductBlockPropsType> = (props) => {
    const formRef = useRef<HTMLFormElement>(null);

    const [editData, setEditData] = useState<BillOfMaterialsProductType>(initData);
    const [editErrors, setEditErrors] = useState<FormErrorsType>({});

    const changeValue = (key: EditKeysType, value: any, error: boolean) => {
        const newData = { ...editData };
        const newErrors = { ...editErrors };
        newData[key] = value;
        newErrors[key] = error;
        setEditData(newData);
        setEditErrors(newErrors);
    };

    const handleAddRow = () => {
        const newFormErrors = checkFormValidity(formRef);

        if (!Object.keys(newFormErrors).length) {
            const newId = Math.min.apply(0, [0, ...(props.data || []).map((item: any): any => item.ID)]) - 1;

            props.onChange([
                ...(props.data || []),
                {
                    ...editData,
                    ID: newId,
                },
            ]);

            setEditData(initData);
        }

        setEditErrors(newFormErrors);
    };

    return (
        <>
            <Typography gutterBottom variant="h3" sx={props.editErrors.PRODUCTS ? { color: colors.alert_O } : {}}>
                {translate('billOfMaterialsDetail.action.addBillOfMaterials')}
            </Typography>
            <form ref={formRef}>
                <Grid>
                    <GridItem cols={6}>
                        <ProductsSelect
                            value={editData.ID_PRODUCT}
                            error={editErrors.ID_PRODUCT}
                            idKey="ID"
                            onChange={(value, error) => {
                                if (!Array.isArray(value)) {
                                    changeValue('ID_PRODUCT', value?.ID, error);
                                }
                            }}
                            name="ID_PRODUCT"
                            label={translate('billOfMaterialsDetail.productsTable.product')}
                            fullWidth
                            disabled={props.disableEdit}
                            required
                        />
                    </GridItem>
                    <GridItem cols={4}>
                        <TextField
                            value={editData.COUNT}
                            error={editErrors.COUNT}
                            onChange={(value, error) => changeValue('COUNT', value, error)}
                            name="COUNT"
                            label={translate('billOfMaterialsDetail.productsTable.count')}
                            fullWidth
                            required
                            type="numberLocale"
                            min={1}
                            disabled={props.disableEdit}
                        />
                    </GridItem>
                    <GridItem cols={2}>
                        <Button
                            onClick={handleAddRow}
                            disabled={props.disableEdit}
                            sx={{ marginTop: sizes.input_top_PD }}
                            mobileFullWidht
                        >
                            + {translate('billOfMaterialsDetail.productsTable.action.add')}
                        </Button>
                    </GridItem>
                </Grid>
            </form>
        </>
    );
};

export default NewProductBlock;
